module.exports = __webpack_public_path__ + "img/bgIcon_4.4bae9cd2.png";